export default "__VITE_ASSET__u6IQ8wda__"